module.exports = __webpack_public_path__ + "static/media/activity-icon-hover-af.b32673b4.svg";